import type { LibraryFileType } from '@/enums/LibraryFileType'

const studentKeys = {
  all: ['students'] as const,
  student: (studentId: Ref<number>) => [...studentKeys.all, studentId] as const,
  settings: (studentId: Ref<number>) => [...studentKeys.student(studentId), 'settings'] as const,
}

const studentProgrammeKeys = {
  all: ['studentProgrammes'] as const,
  studentProgrammes: (studentId: Ref<number>, hasQuestionnaire: boolean) => [...studentProgrammeKeys.all, studentId, hasQuestionnaire] as const,
}

const notificationsKeys = {
  all: ['notifications'] as const,
  notifications: (studentId: Ref<number>) => [...notificationsKeys.all, studentId] as const,
}

const studentActivityKeys = {
  all: ['studentActivities'] as const,
  studentActivities: (studentId: Ref<number>) => [...studentActivityKeys.all, studentId] as const,
  studentActivity: (studentId: Ref<number>, studentActivityId: Ref<number>) => [...studentActivityKeys.studentActivities(studentId), studentActivityId] as const,
  messages: (studentId: Ref<number>, studentActivityId: Ref<number>) => [...studentActivityKeys.studentActivity(studentId, studentActivityId), 'messages'] as const,
}

const studentActivityTypesAndSkillsKeys = {
  all: ['activityTypesAndSkills'] as const,
  studentActivityTypesAndSkills: (studentId: Ref<number>) => [...studentActivityTypesAndSkillsKeys.all, studentId] as const,
}

const libraryFileKeys = {
  all: ['libraryFiles'] as const,
  libraryFiles: (studentId: Ref<number>, type: LibraryFileType) => [...libraryFileKeys.all, studentId, type] as const,
  libraryFolderFiles: (libraryFolderId: Ref<number>) => [...libraryFileKeys.all, libraryFolderId] as const,
}

const libraryFolderKeys = {
  all: ['libraryFolders'] as const,
  libraryFolders: (studentId: Ref<number>) => [...libraryFolderKeys.all, studentId] as const,
}

const interviewKeys = {
  all: ['interviews'] as const,
  interviews: (studentId: Ref<number>) => [...interviewKeys.all, studentId] as const,
  interview: (studentId: Ref<number>, interviewId: Ref<number>) => [...interviewKeys.interviews(studentId), interviewId] as const,
}

const organisationKeys = {
  all: ['organisations'] as const,
  groups: (organisationId: Ref<number>) => [...organisationKeys.all, organisationId, 'groups'] as const,
}

const userKeys = {
  all: ['users'] as const,
  user: (userId: Ref<number>) => [...userKeys.all, userId] as const,
  editUser: (userId: Ref<number>) => [...userKeys.user(userId), userId, 'edit'] as const,
}

export {
  studentKeys,
  studentProgrammeKeys,
  notificationsKeys,
  studentActivityKeys,
  studentActivityTypesAndSkillsKeys,
  libraryFileKeys,
  libraryFolderKeys,
  interviewKeys,
  organisationKeys,
  userKeys,
}
